import { loaderMarkup } from "../components";
import { appContent } from "../content";
import { mobileWorkspaceNav } from "../layout";
import type { SavedAnswer } from "../types";
import { escapeHtml } from "../utils";

// The clause library lives in ./library.ts — it owns a persistent menu, so it
// needs a DOM lifecycle of its own rather than a render-per-selection.

type SavedAnswersScreenOptions = {
  savedAnswers: SavedAnswer[];
  renderWorkspace: (content: string) => void;
  bindWorkspaceNavigation: () => void;
  openSearch: () => void;
  removeSavedAnswer: (id: string | undefined) => void;
  rerender: () => void;
};

export function renderSavedAnswersScreen(options: SavedAnswersScreenOptions): void {
  options.renderWorkspace(`
    <section class="saved-workspace workspace-panel">
      <div class="workspace-header">
        <div>
          <h1>${appContent.saved.heading}</h1>
          <p class="muted">${appContent.saved.body}</p>
        </div>
        <button id="savedAskButton" class="secondary" type="button">${appContent.saved.askAnother}</button>
      </div>
      ${options.savedAnswers.length ? `
        <div class="saved-list">
          ${options.savedAnswers.map((item) => `
            <article class="saved-card">
              <div>
                <span class="eyebrow">${escapeHtml(item.clauses.join(" / "))}</span>
                <h2>${escapeHtml(item.question)}</h2>
                <p>${escapeHtml(item.summary)}</p>
              </div>
              <button class="ghost removeSavedButton" type="button" data-saved-id="${escapeHtml(item.id)}">${appContent.saved.remove}</button>
            </article>
          `).join("")}
        </div>
      ` : `
        <div class="empty-state">
          ${loaderMarkup("success", appContent.saved.emptyLoader)}
          <h2>${appContent.saved.emptyHeading}</h2>
          <p>${appContent.saved.emptyBody}</p>
        </div>
      `}
      ${mobileWorkspaceNav("saved")}
    </section>
  `);
  options.bindWorkspaceNavigation();
  document.querySelector<HTMLButtonElement>("#savedAskButton")?.addEventListener("click", options.openSearch);
  document.querySelectorAll<HTMLButtonElement>(".removeSavedButton").forEach((button) => {
    button.addEventListener("click", () => {
      options.removeSavedAnswer(button.dataset.savedId);
      options.rerender();
    });
  });
}
